"use client";

import { useSyncExternalStore } from "react";

// Ачивки наблюдателя: хранятся в браузере, всплывают уведомлением и собираются в удостоверение.
export type AchId = "first" | "persistent" | "skeptic" | "council" | "night" | "sponsor" | "seeker" | "notpigeon" | "author";

export const ACHIEVEMENTS: Record<AchId, { title: string; text: string }> = {
  first: { title: "Первое наблюдение", text: "Институт записал вас в свидетели. Доказательств не попросил." },
  persistent: { title: "Упорство", text: "Десять наблюдений. Учёный совет подозревает, что птенец ходит за вами." },
  skeptic: { title: "Скептик", text: "Поверили в версию и передумали. Так и делается наука." },
  council: { title: "Учёный совет", text: "Поверили во все пять версий сразу. Вас ждут на заседании." },
  night: { title: "Ночной дозор", text: "Зашли после полуночи. Голуби тоже не спят, но делают вид." },
  sponsor: { title: "Спонсор науки", text: "Положили снаряжение в корзину. Экспедиция вам признательна." },
  seeker: { title: "Искатель", text: "Тридцать секунд искали птенца. Институт ищет 39 лет — вы на верном пути." },
  notpigeon: { title: "Не голубь", text: "Прошли проверку с третьей попытки. Это нормально." },
  author: { title: "Автор версии", text: "Предложили свою версию. Учёный совет рассматривает её с интересом и тревогой." },
};

const KEY = "nii-achievements";
const EVENT = "nii:achievement";
let got: AchId[] = [];
let loaded = false;
const listeners = new Set<() => void>();

function load() {
  if (loaded || typeof window === "undefined") return;
  loaded = true;
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || "[]");
    if (Array.isArray(saved)) got = saved.filter((x): x is AchId => x in ACHIEVEMENTS);
  } catch {
    /* без хранилища ачивки живут до перезагрузки */
  }
}

export function unlock(id: AchId) {
  load();
  if (got.includes(id)) return;
  got = [...got, id];
  try {
    localStorage.setItem(KEY, JSON.stringify(got));
  } catch {
    /* см. выше */
  }
  listeners.forEach((l) => l());
  window.dispatchEvent(new CustomEvent(EVENT, { detail: id }));
}

export function onUnlock(fn: (id: AchId) => void) {
  const h = (e: Event) => fn((e as CustomEvent<AchId>).detail);
  window.addEventListener(EVENT, h);
  return () => window.removeEventListener(EVENT, h);
}

const EMPTY: AchId[] = [];
export function useAchievements() {
  return useSyncExternalStore(
    (fn) => {
      load();
      listeners.add(fn);
      fn();
      return () => listeners.delete(fn);
    },
    () => got,
    () => EMPTY
  );
}

// личный счётчик наблюдений — тот же ключ, что у кликера
export const MINE_KEY = "nii-my-sightings";
export function readMine() {
  try {
    return Number(localStorage.getItem(MINE_KEY)) || 0;
  } catch {
    return 0;
  }
}

// открыть удостоверение из любого места
export const CERT_EVENT = "nii:certificate";
export const openCertificate = () => window.dispatchEvent(new Event(CERT_EVENT));
